module.exports = __webpack_public_path__ + "static/media/18a-03_ST-2018-166x133cm-oleo-sobre-tela.c2ed17f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-03_ST-2018-166x133cm-oleo-sobre-tela.jpg
// module id = 221
// module chunks = 0